import { apiFetch, apiJson } from './http';

export type ChannelRow = {
  id: number;
  name: string;
  url?: string | null;
  logo?: string | null;
  epg_id?: string | null;
  channel_number?: number;
  category?: string | null;
  sort_order?: number;
  shift?: number | null;
  catchup_mode?: string | null;
  catchup_days?: number | null;
  catchup_source?: string | null;
  tv_archive?: number | boolean;
  tv_archive_duration?: number | null;
  sync_name?: number | boolean;
  is_hidden?: number | boolean;
};

export async function fetchChannelsIndex(playlistId: string): Promise<ChannelRow[]> {
  const res = await apiFetch(`/api/channels/index.php?playlist_id=${encodeURIComponent(playlistId)}`);
  if (!res.ok) throw new Error(`Channels ${res.status}`);
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function fetchChannel(id: number): Promise<ChannelRow> {
  const res = await apiFetch(`/api/channels/get.php?id=${id}`);
  if (!res.ok) throw new Error(`Channel ${res.status}`);
  return res.json() as Promise<ChannelRow>;
}

export type UpdatePayload = {
  id: number;
  name?: string;
  url?: string | null;
  logo?: string | null;
  epg_id?: string | null;
  channel_number?: number;
  category?: string | null;
  sort_order?: number;
  shift?: number | null;
  catchup_mode?: string | null;
  catchup_days?: number | null;
  catchup_source?: string | null;
  tv_archive?: number;
  tv_archive_duration?: number | null;
  sync_name?: number;
  is_hidden?: number;
};

export async function updateChannel(body: UpdatePayload): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/channels/update.php', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export async function deleteChannel(id: number): Promise<{ success: boolean; message?: string }> {
  return apiJson(`/api/channels/update.php?id=${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function createChannel(payload: Record<string, unknown>): Promise<{
  success: boolean;
  id?: number;
  message?: string;
  already_exists?: boolean;
}> {
  return apiJson('/api/channels/create.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export type StreamCheckStatus = 'online' | 'offline' | 'error';

export type StreamCheckResult = {
  id: number;
  status: StreamCheckStatus;
  http_code?: number;
  detail?: string;
};

export type StreamCheckResponse = {
  success: boolean;
  message?: string;
  timeout_sec?: number;
  concurrency?: number;
  results?: StreamCheckResult[];
};

/** Batch probe of channel stream URLs (owned playlist only). Max 100 ids. */
export async function checkChannelStreams(
  playlistId: number,
  channelIds: number[],
): Promise<StreamCheckResponse> {
  return apiJson('/api/channels/stream_check.php', {
    method: 'POST',
    body: JSON.stringify({ playlist_id: playlistId, channel_ids: channelIds }),
  });
}
